/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer = {
    readonly isRequestMoreImagesEnabled: boolean | null;
    readonly videoUploadToolsFeatureFlag: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_viewer" | "PdpRespHeroCarouselRequestMoreImages_viewer">;
    readonly " $refType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$data = PdpRespHeroCarousel_viewer;
export type PdpRespHeroCarousel_viewer$key = {
    readonly " $data"?: PdpRespHeroCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "alias": "isRequestMoreImagesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
    },
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd546acee9fdef4cc8fd07fbfc71a09d1';
export default node;
